module.exports = __webpack_public_path__ + "static/media/57.37d37f0.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/57.wav
// module id = itQf
// module chunks = 0